<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <div class="row position-relative">

                    <div class="col-12 col-md-7 mt-5">
                        <item-image-carousel :plugin-path="pluginPathCeres" image-url-accessor="url" />
                    </div>

                    <div class="col-12 col-md-5 mt-md-5">
                        <div v-stick-in-parent>
                            <!-- START SINGLEITEM_DETAILS -->
                            <div class="producertag h6 producer text-muted"
                                v-if="currentVariation.filter.hasManufacturer">
                                {{ currentVariation.item.manufacturer.externalName }}
                            </div>

                            <h1 class="h2 title">
                                <span>
                                    {{ currentVariation | itemName }}
                                </span>
                            </h1>

                            <slot name="tag-list"></slot>

                            <p class="single-description"
                                v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                                v-html="currentVariation.texts.shortDescription"></p>

                            <hr>

                            <div class="mb-5">
                                <span class="articlenumber small text-muted">
                                    <b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
                                    <span>{{ currentVariation.variation.number }}</span>
                                </span>
                            </div>

                            <!-- Variation -->
                            <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->

                            <!-- Item Bundle -->
                            <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                :bundle-type="currentVariation.variation.bundleType"
                                :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            <!-- /Item Bundle -->

                            <slot name="before-price"></slot>

                            <!--                            <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">-->
                            <!--                                <order-property-list></order-property-list>-->
                            <!--                            </div>-->

                            <!--                            <graduated-prices></graduated-prices>-->

                            <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                            <slot name="after-price"></slot>

                            <item-availability></item-availability>

                            <div class="my-3">
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>

                                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                                </div>
                                <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3">
                                    <add-to-basket :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function (prop) { return prop.property.isOderProperty })"
                                        :has-order-properties="currentVariation.hasOrderProperties"
                                        :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                        :use-large-scale="false" :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice">
                                    </add-to-basket>
                                </div>

                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>

                            <div v-if="isWishListEnabled" class="row">
                                <div class="col-12">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>
                            <!-- ./ITEM DETAIL -->

                            <slot name="additional-content-after-add-to-basket"></slot>

                            <hr>

                            <span class="vat small text-muted">
                                {{ $translate("Ceres::Template.singleItemFootnote1") }} <template
                                    v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT")
                                    }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT")
                                    }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}
                                <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts"
                                    :title="$translate('Ceres::Template.singleItemShippingCosts')">{{
            $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                                <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{
            $translate("Ceres::Template.singleItemShippingCosts") }}</a>

                            </span>

                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>

                    <div class="col-12 col-md-7">
                        <!-- ITEM DESCRIPTION -->
                        <div class="my-5">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active" data-toggle="tab"
                                        :href="'#details-' + currentVariation.variation.id" role="tab">{{
            $translate("Ceres::Template.singleItemDescription") }}</a>
                                </li>

                                <li class="nav-item" v-if="isTechnicalDataTabActive">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab"
                                        :href="'#data-' + currentVariation.variation.id" role="tab">{{
            $translate("Ceres::Template.singleItemTechnicalData") }}</a>
                                </li>

                                <li class="nav-item">
                                    <a :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }"
                                        class="nav-link" data-toggle="tab" href="#assessments-details" role="tab">{{
            $translate("Ceres::Template.singleItemMoreDetails") }}</a>
                                </li>

                                <slot name="add-detail-tabs"></slot>
                            </ul>

                            <div class="tab-content overflow-hidden">
                                <div class="tab-pane active overflow-auto"
                                    :id="'details-' + currentVariation.variation.id" role="tabpanel"
                                    v-if="isDescriptionTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.description">
                                    </div>
                                </div>

                                <div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                    class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id"
                                    role="tabpanel" v-if="isTechnicalDataTabActive">
                                    <div class="my-4" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </div>

                                <div :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }"
                                    class="tab-pane overflow-auto" id="assessments-details" role="tabpanel">
                                    <div class="my-4">
                                        <table class="table table-striped table-hover table-sm">
                                            <tbody>
                                                <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                                                    <td>{{ currentVariation.item.id }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemCondition") }}</td>
                                                    <td>{{ currentVariation.item.condition.names.name }}</td>
                                                </tr>

                                                <tr
                                                    v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemAge") }}</td>
                                                    <td>{{ currentVariation.item.ageRestriction | ageRestriction }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemExternalVariationId")
                                                        }}</td>
                                                    <td>{{ currentVariation.variation.externalId }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                                                    <td>{{ currentVariation.variation.model }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== '' && (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                                                    <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.item.producingCountry && currentVariation.item.producingCountry.names.name !== '' && (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemManufacturingCountry")
                                                        }}</td>
                                                    <td>{{ currentVariation.item.producingCountry.names.name }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemContent") }}</td>
                                                    <td>{{ currentVariation.unit.content }} {{
            currentVariation.unit.names.name }}</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                                                    <td>{{ currentVariation.variation.weightG }} g</td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemNetWeight") }}</td>
                                                    <td>{{ currentVariation.variation.weightNetG }} g</td>
                                                </tr>

                                                <tr
                                                    v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                                                    <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                                                    <td>
                                                        <span>{{ currentVariation.variation.lengthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.widthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.heightMM }}</span> mm
                                                    </td>
                                                </tr>

                                                <tr
                                                    v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                                                    <td>{{ $translate("Ceres::Template.singleItemCustomsTariffNumber")
                                                        }}</td>
                                                    <td>{{ currentVariation.variation.customsTariffNumber }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <slot name="add-detail-tabs-content"></slot>
                            </div>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>

                </div>

                <slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import TranslationService from "ceres/app/services/TranslationService";
import NotificationService from "ceres/app/services/NotificationService";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],
    data() {
        return {
            tableHeight: null,
            itemscopeBottom: 0,
            uspContainerTop: 0
        }
    },

    computed:
    {
        pluginPathCeres() {
            return App.pluginPathCeres;
        },

        variationGraduatedPrice() {
            return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
        },

        itemConfig() {
            return App.config.item.itemData;
        },

        isRecommendedPriceActive() {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive() {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        variationGroupedProperties() {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties() {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        },

        formattedShippingPrice() {
            const shippingCosts = this.currentVariation.variation.defaultShippingCosts;
            if (shippingCosts > 0) {
                return shippingCosts.toLocaleString('de-DE', { style: 'currency', currency: this.variationGraduatedPrice.currency });
            }

            return '0';
        },

        hasAttributesAndAreSelected() {
            if (this.attributes.length > 0 && this.attributes.length === this.currentVariation.attributes.length) {
                return true;
            } else if (this.attributes.length == 0) {
                return true;
            }
            return false;
        },

        ShippingText() {
            if (this.currentVariation.variation.defaultShippingCosts > 0) {
                return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsWithPrice", { "value": this.formattedShippingPrice });
            } else {
                return TranslationService.translate("Weberbuero::Template.singleItemShippingCostsPriceIncluded");
            }

        },

        hasDimensions() {
            const variationData = this.currentVariation.variation;
            if (this.isZeroOrNull(variationData.lengthMM) && this.isZeroOrNull(variationData.widthMM) && this.isZeroOrNull(variationData.heightMM)) {
                return false;
            }
            return true;

        },

        sortedProperties() {
            return this.currentVariation.properties.sort((a, b) => {
                return a.property.position - b.property.position
            }
            );
        },

        serienButtonUrl() {
            if (typeof this.currentVariation.variationProperties !== 'undefined') {
                if (this.currentVariation.variationProperties.find(x => x.propertyId === 4)) {
                    return this.currentVariation.variationProperties.find(x => x.propertyId === 4).values.value.trim();
                }
            }
            return null;
        },

        serienButtonText() {
            if (this.currentVariation.variationProperties.find(x => x.propertyId === 3)) {
                return this.currentVariation.variationProperties.find(x => x.propertyId === 3).values.value.trim();
            }
            return null;
        },

        isDescriptionTabActive() {
            return App.config.item.itemData.includes("item.description") && !!this.currentVariation.texts.description.length;
        },

        isTechnicalDataTabActive() {
            return App.config.item.itemData.includes("item.technical_data") && !!this.currentVariation.texts.technicalData.length;
        },

        transformedVariationProperties() {
            return transformVariationProperties(this.currentVariation, [], "showInItemListing");
        },

        fancyDetails() {
            if (typeof this.currentVariation.variationProperties !== 'undefined') {
                const details = this.currentVariation.variationProperties.find(prop => prop.propertyId === 7);
                if (!details) {
                    return false;
                } else {
                    return details.values.value;
                }
            } else {
                return false;
            }
        },

        features() {
            if (typeof this.currentVariation.variationProperties !== 'undefined') {
                const details = this.currentVariation.variationProperties.find(prop => prop.propertyId === 9);
                if (!details) {
                    return false;
                } else {
                    return details.values.value;
                }
            } else {
                return false;
            }
        },

        featuresButton() {
            const details = this.currentVariation.variationProperties.find(prop => prop.propertyId === 8);
            if (!details) {
                return "Features";
            } else {
                return details.values.value;
            }
        },

        tableStyle() {
            if (!this.tableHeight) {
                return {};
            }
            return {
                height: Math.ceil(this.tableHeight / 2) + 100 + "px"
            };
        },

    },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted() {
        if ($('.single__table').length) {
            this.calcTableHeight();
        }
        this.$nextTick(() => {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });

            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }

            // TODO: fix delay and CLS of feedback stars, its bad
            let myVar = setInterval(myTimer, 2500);

            function myTimer() {
                if (typeof $(".widget-feedback .feedback-stars-average .feedback-stars-overlay-wrap").attr("style") !== "undefined") {
                    if ($(".widget-feedback .feedback-stars-average .feedback-stars-overlay-wrap").attr("style") !== "width: 0%;" &&
                        $(".widget-feedback .feedback-stars-average .feedback-stars-overlay-wrap").attr("style") !== "width:NaN%;") {
                        myStopFunction();

                        const clone = $(".widget-feedback .feedback-stars-average").clone();

                        if ($('.feedback-average-count').text().trim() == '(0)') {
                            //$('.single__rating').hide(); // no hide?!
                        } else {
                            $(".single__rating .single__feedback-stars").html(clone);
                            $('.single__rating').addClass("single__rating--is-visible")
                        }
                    }
                }
            }

            function myStopFunction() {
                clearInterval(myVar);
            }

            let that = this;
            if (App.templateEvent == "tpl.item") {
                function myTimer1() {
                    if ($('div[itemscope="itemscope"]').length && !!document.querySelector(".has-loaded")) {
                        myStopFunction1();

                        that.itemscopeBottom = $('div[itemscope="itemscope"]')[0].getBoundingClientRect().bottom;
                        that.uspContainerTop = $('.single__wrapper .homepage__image-text-widget--container')[0].getBoundingClientRect().top;
                    }
                }

                let myVar = setInterval(myTimer1, 1000);

                function myStopFunction1() {
                    clearInterval(myVar);
                }
            }

            var checkScrollSpeed = (function (settings) {
                settings = settings || {};

                var lastPos, newPos, timer, delta,
                    delay = settings.delay || 5; // in "ms" (higher means lower fidelity )

                function clear() {
                    lastPos = null;
                    delta = 0;
                }

                clear();

                return function () {
                    newPos = window.scrollY;
                    if (lastPos != null) { // && newPos < maxScroll
                        delta = newPos - lastPos;
                    }
                    lastPos = newPos;
                    clearTimeout(timer);
                    timer = setTimeout(clear, delay);
                    return delta;
                };
            })();

            function isElementVisible(el) {
                var top = el.offsetTop;
                var left = el.offsetLeft;
                var width = el.offsetWidth;
                var height = el.offsetHeight;

                while (el.offsetParent) {
                    el = el.offsetParent;
                    top += el.offsetTop;
                    left += el.offsetLeft;
                }

                return (
                    top < (window.pageYOffset + window.innerHeight) &&
                    left < (window.pageXOffset + window.innerWidth) &&
                    (top + height) > window.pageYOffset &&
                    (left + width) > window.pageXOffset
                );
            }

            window.addEventListener("scroll", function () {
                if (window.matchMedia("(min-width: 992px)").matches && checkScrollSpeed() < 70) {

                    if ($('.single__wrapper').length && $('.homepage__image-text-widget--container').length && $('div[itemscope="itemscope"]').length) {
                        // diff < 20, stop adding more top abstand
                        let diff = $('.homepage__image-text-widget--container')[0].getBoundingClientRect().top - $('div[itemscope="itemscope"]')[0].getBoundingClientRect().bottom;
                        let offsetNoPx = $(window).scrollTop() - 109;
                        let maxOffset = that.uspContainerTop - that.itemscopeBottom - 60;
                        let offset = $(window).scrollTop() - 109 + 'px';
                        if ($('div[itemscope="itemscope"]').offset().top - 153 < $(window).scrollTop()) {
                            if (diff >= 25 && checkScrollSpeed() < 70 && isElementVisible($('div[itemscope="itemscope"]')[0]) && offsetNoPx <= maxOffset) {
                                $('div[itemscope="itemscope"]').css('transform', 'translate(0px, ' + offset + ')');
                            } else {
                                if (diff <= 0) {
                                    $('div[itemscope="itemscope"]').css('transform', 'translate(0px, 0px)')
                                }
                            }
                        } else {
                            if (diff <= -25) {
                                $('div[itemscope="itemscope"]').css('transform', 'translate(0px, 0px)')
                            }
                            if ($(window).scrollTop() < 153) {
                                $('div[itemscope="itemscope"]').css('transform', 'translate(0px, 0px)')
                            }
                        }
                    }
                }
            }, detectPassiveEvents() ? { passive: true } : false);

            $('.title-outer h1').addClass("single__name");

            $('#muster__send').click(function (ev) {
                ev.preventDefault();

                return false;

                let sel;

                if ($(this).closest('#confi-muster').length) {
                    sel = '#confi-muster';
                } else {
                    sel = '#muster';
                }

                $(".has-error").removeClass("has-error");

                var isAllFilled = true;

                $.each($(sel + " .input-unit [required]"), function (index, item) {
                    if ($(item).val() == "") {
                        $(item).addClass("has-error");
                        isAllFilled = false;
                    }
                });

                var $gtc = $('#gtc-accept-muster-confi').length ? $('#gtc-accept-muster-confi') : $(sel + " .gtc-checkbox");

                if ($gtc.prop('checked') === false) {
                    isAllFilled = false;
                }

                if (isAllFilled) {

                    const mailObj =
                    {
                        salutation: $(sel + " [name=\"salutation\"]").val(),
                        email: $(sel + " [name=\"email\"]").val(),
                        name: $(sel + " [name=\"name\"]").val(),
                        lastname: $(sel + " [name=\"lastname\"]").val(),
                        company: $(sel + " [name=\"company\"]").val(),
                        street: $(sel + " [name=\"street\"]").val(),
                        number: $(sel + " [name=\"number\"]").val(),
                        plz: $(sel + " [name=\"plz\"]").val(),
                        place: $(sel + " [name=\"place\"]").val(),
                        country: $(sel + " [name=\"country\"]").val(),
                        article: $('.configurator').length > 0 ? $("#muster-selected-article").attr("muster-selection") : $('.muster__modal input[name="article"]').val(),
                        articlename: $('.configurator').length > 0 ? $("#muster-selected-article").attr("muster-selection") : $('.muster__modal input[name="articlename"]').val(),
                        message: "xx",
                        userMail: "xx",
                        subject: "xx",
                        type: "muster"
                    };

                    $.ajax({
                        url: "https://www.weberbuero.de/rest/weberbuero/customer/contact/mail",
                        type: "POST",
                        async: true,
                        data: {
                            contactData: mailObj,
                            template: "Weberbuero::Customer.Components.Contact.MusterMail",
                            type: "muster"
                        },
                        success: function (data, textStatus, jqXHR) {
                            // success
                            $(sel).modal("hide");

                            NotificationService.success(
                                TranslationService.translate("Weberbuero::Template.musterSendSuccess")
                            ).closeAfter(10000);
                        },
                        error: function (data) {
                        }
                    });

                }
            });

            setTimeout(function () {
                window.scrollTo(0, 1);
            }, 500);
        });

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },
    methods:
    {
        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes) {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate") {
                    component.hydrate();
                }
                else if (component.$children.length) {
                    this.hydrateChildren(component.$children);
                }
            })
        },

        getDataField(field) {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter) {
            if (!isNullOrUndefined(this.$options.filters[filter])) {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        isZeroOrNull(value) {
            return value == 0 || !value;
        },
        calcTableHeight() {
            if (window.innerWidth >= 992) {

                this.tableHeight = null;
                this.$nextTick(() => {
                    let table = $('.single__table')[0];
                    const elHeight = table.offsetHeight;
                    // do some calculations based on height
                    this.tableHeight = elHeight;
                });

            }
        },
        // TODO: find another way to handle changes
        articleChangeHandler() {
            if (this.$refs && $('.single__table')[0]) {
                this.calcTableHeight();
            }
        }
    },
}
</script>
